import * as React from 'react';
import {
  PaletteMode,
  alpha,
  ButtonProps,
  ScopedCssBaseline,
  ThemeProvider,
  useMediaQuery,
} from '@mui/material';

import { PaletteModeWithSystem } from '@library/types';

import { createMergedTheme } from '../core';

const themeOptions = () => ({
  palette: {
    primary: {
      main: '#2D2BB3',
      light: '#5755C2',
      dark: '#1F1E7D',
      contrastText: '#FFFFFF',
      background: alpha('#2D2BB3', 0.07),
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        size: 'large' as ButtonProps['size'],
      },
    },
  },
  shape: {
    borderRadius: 3,
  },
});

export const PublicThemeProvider = ({
  children,
  mode = 'light',
}: {
  children: React.ReactNode;
  mode?: PaletteModeWithSystem;
}) => {
  const systemMode = useMediaQuery('(prefers-color-scheme: dark)')
    ? 'dark'
    : 'light';
  const screenMode: PaletteMode = mode === 'system' ? systemMode : mode;
  return (
    <ThemeProvider theme={createMergedTheme(themeOptions(), false, screenMode)}>
      <ScopedCssBaseline>{children}</ScopedCssBaseline>
    </ThemeProvider>
  );
};
